const dataColumns = [
  [
    "Quiz 1",
    "85%",
    "94%",
    "56%",
    "32%",
    "76%",
    "92%",
    "91%",
    "79%",
  ],
  [
    "Quiz 2",
    "56%",
    "24%",
    "65%",
    "23%",
    "67%",
    "29%",
    "19%",
    "97%",
  ],
  [
    "Quiz 3",
    "76%",
    "88%",
    "87%",
    "65%",
    "99%",
    "100%",
    "90%",
    "92%",
  ],
  [
    "Quiz 4",
    "35%",
    "17%",
    "66%",
    "57%",
    "87%",
    "49%",
    "87%",
    "87%",
  ],
  [
    "Quiz 5",
    "53%",
    "71%",
    "66%",
    "75%",
    "78%",
    "94%",
    "78%",
    "78%",
  ],
]

const scores = {
  dataColumns,
  isDummy: true,
}

export default scores